import React, { useState, useEffect } from "react";
import { CDBBtn } from 'cdbreact';
import Select from "react-select";
import Dropzone from './Dropzone';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

export const ModalPurchaseOrders = ({ action, setPressedButton, formData, handleChange, providers, project, userName }) => {

  const [selectedPDF, setSelectedPDF] = useState(formData.BillLink || '');

  let nameFile = formData.BillLink ? formData.BillLink.substring(formData.BillLink.lastIndexOf('/') + 1) : "";

  const providerSelect = providers.map((provider) => ({
    value: provider.Nit,
    label: `Código Proveedor: ${provider.Nit} / Nombre del proyecto: ${provider.ProjectName}`,
  }));

  const stateOptions = [
    { value: "Abierto", label: "Abierto" },
    { value: "Cerrado", label: "Cerrado" }
  ];

  useEffect(() => {
    if(selectedPDF === ''){
      formData.BillLink = ''
    }else if(selectedPDF.split(',')[1] != "" && selectedPDF.split(',')[1] != undefined && selectedPDF.split(',')[1] != null) {
      formData.BillLink = selectedPDF.split(',')[1]
    }
  }, [selectedPDF]);

  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === 'create' ? 'Crear una orden de compra' : 'Editando un orden de compra'}
          </h3>
        </div>
        {action === 'edit' && (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => setPressedButton('delete')}
          >
            <i className="fas fa-trash"></i>
            Eliminar
          </CDBBtn>
        )}
      </div>
      <div className="modal-body">
        {action !== 'create' && (
          <div className="form-group">
            <label>ID de la compra:</label>
            <input
              type="text"
              className="form-control mb-4"
              id="IDPurchase"
              placeholder="Identificador de la compra"
              disabled
              value={formData.IDPurchase}
              onChange={handleChange}
            />
          </div>
        )}
        {action !== 'edit' && (
          <div className="form-group">
            <label>ID de la compra:<span className="text-danger"> *</span></label>
            <input
              type="text"
              className="form-control mb-4"
              id="IDPurchase"
              placeholder="Identificador de la compra"
              value={formData.IDPurchase}
              onChange={handleChange}
            />
          </div>
        )}
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="Nit">Codigo Proveedor:<span className="text-danger"> *</span></label>
            <Select
              id="Nit"
              isDisabled={action === 'edit'}
              placeholder="Código..."
              options={providerSelect}
              value={providerSelect.find(
                (option) => option.value === formData.Nit
              )}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption.value,
                    id: "Nit",
                  },
                })
              }
            />
          </div>
        </div>
        <div className="form-group row mb-4">
          <label htmlFor="StatePurchase">Estado de la orden:<span className="text-danger"> *</span></label>
          <Select
            id="StatePurchase"
            placeholder="Seleccione un estado"
            options={stateOptions}
            value={stateOptions.find((option) => option.value === formData.StatePurchase)}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  value: selectedOption.value,
                  id: "StatePurchase",
                },
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="PurchaseDescription">Observaciones:</label>
          <textarea
            className="form-control mb-4"
            id="PurchaseDescription"
            placeholder="Observaciones de la orden de compra"
            value={formData.PurchaseDescription}
            onChange={handleChange}
          />
        </div>
        <Dropzone project={project} userName={userName} setPressedButton={setPressedButton} setSelectedPDF={setSelectedPDF} purchaseState={true} BillLink={nameFile}/>
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton('closeModal')}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="success"
          className="mr-auto"
          outline
          onClick={() => setPressedButton('submitModal')}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};